<template>
<div >
     

    <!-- ======= Testimonials Section ======= -->
    <section id="services" class="testimonials">
      <div class="container">

       <q-carousel
        v-model="slide"
        transition-prev="scale"
        transition-next="scale"
        swipeable
        animated
        control-color="white"
        navigation
        
        
        class="bg-transparent text-white  "
      >
        <template v-slot:navigation-icon="{ active, btnProps, onClick }">
        <q-btn v-if="active" size="sm" :icon="btnProps.icon" color="blue-9" flat round dense @click="onClick" />
        <q-btn v-else size="sm" :icon="btnProps.icon" color="white" flat round dense @click="onClick" />
      </template>

         <q-carousel-slide name="Ahmed" class="column no-wrap flex-center">
         <img src="../assets/img/ahmed.jpg" class="testimonial-img" alt="">
            <h3>Ahmed Helal   </h3>

                       <h4>Senior Software Engineer  at Jumia</h4>

          <div class="q-mt-md text-center">
            <i class="bx bxs-quote-alt-left quote-icon-left"></i>
            Islam, highly skilled frontend engineer with enhanced skills in ui and design

              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
          </div>
        </q-carousel-slide>


          <q-carousel-slide name="khaled" class="column no-wrap flex-center">
         <img src="../assets/img/khaled.png" class="testimonial-img" alt="">
            <h3>Khaled A. Mousa   </h3>

                       <h4>Technical Manager at Spiritude</h4>

          <div class="q-mt-md text-center">
            <i class="bx bxs-quote-alt-left quote-icon-left"></i>
            It was my pleasure to work with Islam at the same company. He is one of the most talented, fast, committed, and dependable engineers i worked with. I see your performance curve is exponentially increasing. Keep going Islam ❤️ Good luck 👍

              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
          </div>
        </q-carousel-slide>
        <q-carousel-slide name="Mohammed" class="column no-wrap flex-center ">
           <img src="../assets/img/mido4.jpg" class="testimonial-img" alt="">
            <h3>Mohammed Mahmoud </h3>
            <h4>Senior Frontend engineer</h4>
          <div class="q-mt-md text-center">
              <p>
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
            Working with a professional and smart developer give you a comfortable and happy environment and attitude. love working with him for 2 years and hope years and years to come.
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>

          </div>
        </q-carousel-slide>
        <q-carousel-slide name="Youssef" class="column no-wrap flex-center">
         <img src="../assets/img/joe.jpg" class="testimonial-img" alt="">
            <h3>Youssef Zidan  </h3>

                       <h4>Senior Frontend engineer</h4>

          <div class="q-mt-md text-center">
            <i class="bx bxs-quote-alt-left quote-icon-left"></i>
            Hard worker, very smart! Love working with him
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
          </div>
        </q-carousel-slide>
    
     
      </q-carousel>

      </div>
    </section><!-- End Testimonials Section -->
</div>
</template>

<script>
export default {
  data () {
    return {
      slide: 'khaled',
      lorem: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque voluptatem totam, architecto cupiditate officia rerum, error dignissimos praesentium libero ab nemo.'
    }
  }
}
</script>

<style >
.q-carousel__navigation .q-btn
{
    margin: 6px 20px !important;
}
h3
{
        line-height: 1.125rem !important;

}
</style>